export const DEFAULT_VIEWPORT: Record<string, {latitude: number, longitude: number, zoom: number}> = {
  it: {latitude: 42.10861482210585, longitude: 12.642002778912707, zoom: 5},
  es: {latitude: 40.57517348809379, longitude: -2.929007358602821, zoom: 5},
}
